import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';

/**
 * Thin wrapper for the standard Admin Cancel action.
 * Composes app-button with secondary variant and shared defaults.
 */
@Component({
  selector: 'app-admin-cancel-button',
  templateUrl: './admin-cancel-button.component.html',
  styleUrls: ['./admin-action-button.scss'],
  host: {
    '[class]': 'hostClass',
  },
})
export class AdminCancelButtonComponent {
  /** Host-level layout classes (e.g. float-right, order-1) */
  @Input() hostClass = '';
  /** Translation key for the button label */
  @Input() labelKey = 'admin.global.cancel';
  /** Optional test id forwarded to the rendered button */
  @Input() dataTestid = 'cancel-button';
  @Input() disabled = false;
  @Input() size: 'small' | 'medium' | 'large' | 'default' = 'medium';
  /** Additional CSS classes for the inner button element */
  @Input() classes = '';
  /** Optional translation key for the title attribute */
  @Input() titleKey: string;
  /** When set, navigates on click (in addition to emitting cancel) */
  @Input() routerLink: any[] | string;
  @Input() queryParams: Params;
  /** When set (including `false`), closes a mat-dialog via MatDialogClose */
  @Input() matDialogClose: unknown;

  @Output() cancelled = new EventEmitter<Event>();

  onClick(event: Event): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    this.cancelled.emit(event);
  }
}
